import { render, staticRenderFns } from "./ot-edit-contract-details.vue?vue&type=template&id=caad9840&scoped=true&"
import script from "./ot-edit-contract-details.vue?vue&type=script&lang=ts&"
export * from "./ot-edit-contract-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-edit-contract-details.vue?vue&type=style&index=0&id=caad9840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caad9840",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VMenu})
